// @ts-check

import locale from '@/configs/locale.js'

// Import locales pack for veutify (add / remove desired locales)

// @ts-ignore
import zhHant from 'vuetify/src/locale/zh-Hant.ts'
import { PortalUtils } from '@/utils/PortalUtils.js'

const themeMap = {
  home: {
    light: {
      primary: '#f3af1a',
      secondary: '#54595F',
      accent: '#61CE70'
    }
  },
  press: {
    light: {
      primary: '#b1a083',
      secondary: '#54595F',
      accent: '#61CE70'
    }
  },
  learn: {
    light: {
      primary: '#f18e24',
      secondary: '#54595F',
      accent: '#61CE70'
    }
  },
  collab: {
    light: {
      primary: '#c2454a',
      secondary: '#54595F',
      accent: '#61CE70'
    }
  },
  advisory: {
    light: {
      primary: '#8dbe3e',
      secondary: '#54595F',
      accent: '#61CE70'
    },
    dark: {
      primary: '#00B1A9',
      secondary: '#54595F',
      accent: '#61CE70'
    }
  }
}
export default {
  /**
   * Defines icon settings in vuetify  
   * Currently installed fonts: [mdi, FontAwesome6]
   * @see https://vuetifyjs.com/en/features/icon-fonts/
   */
  icons: {
    iconfont: 'mdi'
  },
  /**
   * Defines i18n settings in vuetify
   * @see https://vuetifyjs.com/en/features/internationalization/
   */
  lang: {
    locales: { zhHant },
    current: locale.currentLocale
  },
  /**
   * Defines theme related settings in vuetify
   * @see https://vuetifyjs.com/en/features/theme/
   */
  theme: {
    options: { customProperties: true },
    themes: themeMap[PortalUtils.name]
    // {
    //   light: {
    //     primary: '#90b942',
    //     secondary: '#54595F',
    //     accent: '#61CE70'
    //   }

    // }
  }
}
